import React from 'react';

import {
  mergeClassNameStrings,
  normalizeProgressValues,
  ProgressT,
} from '@consumer-frontend/nc-utils';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/apply/progress-bar.scss';

export type NcProgressBarPropsT = {
  progress: ProgressT;
  ariaLabel?: string;
  className?: string;
};

export const NcProgressBar = ({
  className,
  progress,
  ariaLabel = 'Application Progress',
}: NcProgressBarPropsT): React.JSX.Element | null => {
  const normalizedProgress = normalizeProgressValues(progress);

  if (normalizedProgress.total <= 0 || normalizedProgress.current <= 0) {
    return null;
  }

  return (
    <div className={mergeClassNameStrings('nc-progress-bar', className)}>
      <div
        aria-label={ariaLabel}
        aria-valuemax={normalizedProgress.total}
        aria-valuemin={0}
        aria-valuenow={normalizedProgress.current}
        className="nc-progress-bar__track"
        role="progressbar"
      >
        {Array.from({ length: normalizedProgress.total }, (_, index) => {
          const isStepComplete = index < normalizedProgress.current;

          return (
            <span
              className={mergeClassNameStrings(
                'nc-progress-bar__slot',
                isStepComplete ? 'nc-progress-bar__slot--complete' : undefined,
              )}
              key={`progress-slot-${index + 1}`}
            />
          );
        })}
      </div>

      <span className="nc-progress-bar__step">{`${normalizedProgress.current}/${normalizedProgress.total}`}</span>
    </div>
  );
};
